import { PeriodType } from '@amzn/claritygqllambda';

export const PERIOD_TYPE_OFFSET = {
  [PeriodType.Ttm]: 11,
  [PeriodType.T6m]: 5,
  [PeriodType.T3m]: 2,
  [PeriodType.Pm]: 1,
};
